import { act, createContext, PropsWithChildren, useContext, useEffect, useMemo, useRef, useState } from "react"
import { proxy, useSnapshot } from "valtio"
import { FerveAPI, FerveMode } from "./ferve-api-client"
import { RouteState, useRoute, useRouter, useRouterEvents } from "eddev/routing"

const FerveContext = createContext<FerveAPI>(null!)

let client: FerveAPI

const getFerveMode = (route: RouteState): FerveMode => {
  if (route.pathname.startsWith("/tff")) return "tff"
  return "sff"
}

export function FerveProvider(props: PropsWithChildren<{}>) {
  const router = useRouter()
  const [mode, setMode] = useState<FerveMode>(() => {
    const activeRoute = router.getState()?.activeRoute
    if (!activeRoute) return "sff"
    return getFerveMode(activeRoute)
  })
  useRouterEvents((event) => {
    if (event.type === "navigate:changed") {
      const newMode = getFerveMode(event.currentRoute)
      setMode(newMode)
    }
  })

  if (!client || client.mode !== mode || client instanceof FerveAPI === false) {
    client = proxy(new FerveAPI(mode))
  }

  const lastClientRef = useRef(client)

  useEffect(() => {
    // @ts-ignore
    window.ferve = client
    client.init()
    if (lastClientRef.current && client !== lastClientRef.current) {
      lastClientRef.current.destroy()
    }
    lastClientRef.current = client
  }, [client])

  return <FerveContext.Provider value={client}>{props.children}</FerveContext.Provider>
}

export const useFerve = () => {
  return useContext(FerveContext)
}

export function useFerveSession() {
  const ferve = useFerve()
  const state = useSnapshot(ferve)
  return state.session
}

export function useFerveUserId() {
  const ferve = useFerve()
  const [userId, setUserId] = useState<string | null>(null)
  const session = useFerveSession()

  useEffect(() => {
    setUserId(null)
    // if (session?.hash && session.loggedIn) {
    //   ferve
    //     .getUserId()
    //     .then((id) => {
    //       if (id) {
    //         setUserId(id)
    //       }
    //     })
    //     .catch((error) => {
    //       console.error("Failed to fetch Ferve User ID:", error)
    //     })
    // }
  }, [session?.hash])

  return userId
}

export function getFerve() {
  return client
}
